import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { LoginCallback, Security, SecureRoute } from '@okta/okta-react';
import { Home } from './Home';

const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_HD_TOOLS_OKTA_URI,
  clientId: process.env.REACT_APP_HD_TOOLS_CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  logoutUrl: window.location.origin,
  scopes: ["openid", "profile", "email"]
});

class App extends Component {
  constructor(props) {
    super(props);
    this.restoreOriginalUri = async (_oktaAuth, originalUri) => {
      props.history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    };
  }

  render() {
    return (
      <Security oktaAuth={oktaAuth} restoreOriginalUri={this.restoreOriginalUri}>
        <Switch>
          {/* Protected home route */}
          <SecureRoute exact path="/" component={Home} />

          {/* Okta login redirect route */}
          <Route path="/login/callback" component={LoginCallback} />

          {/* Redirect everything else to "/" */}
          <Route path="*">
            <Redirect to="/" />
          </Route>
        </Switch>
      </Security>
    );
  }
}

const AppWithRouterAccess = withRouter(App);

class RouterApp extends Component {
  render() {
    return (
      <Router>
        <AppWithRouterAccess />
      </Router>
    );
  }
}

export default RouterApp;
